interface Props {
  label?: string;
}

export function Spinner({ label }: Props) {
  return (
    <div
      className="flex items-center gap-3 text-sm text-muted-foreground"
      role="status"
      aria-live="polite"
    >
      <div
        className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"
        aria-hidden="true"
      />
      {label && <span>{label}</span>}
    </div>
  );
}
